// Origin-aware, refresh-safe back navigation.
// Origins encode where to return via a ?from=<encoded path+search> query param.
// Only internal, allow-listed app paths are honored; anything else falls back safely.

const ALLOWED_PREFIXES = ['/accounts-receivable', '/invoices', '/customers/'];

// Build the value for a ?from= param from a react-router location.
export function buildReturnParam(location) {
  if (!location) return '';
  const raw = `${location.pathname || ''}${location.search || ''}`;
  return encodeURIComponent(raw);
}

// Label shown on the back button for a given internal path.
export function labelForReturn(path) {
  if (path.startsWith('/accounts-receivable')) return 'Back to Accounts Receivable';
  if (path.startsWith('/customers/')) return 'Back to Customer';
  if (path.startsWith('/invoices')) return 'Back to Invoices';
  return 'Back';
}

// Resolve a raw ?from= value into a safe { to, label }. Rejects external/malformed targets.
export function resolveReturn(raw, fallback = '/invoices') {
  const fb = { to: fallback, label: labelForReturn(fallback) };
  if (!raw) return fb;
  let decoded;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return fb;
  }
  // Must be an internal absolute path, never a protocol-relative or external URL.
  if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('://') || /\s/.test(decoded)) {
    return fb;
  }
  const pathOnly = decoded.split('?')[0];
  if (!ALLOWED_PREFIXES.some(p => pathOnly === p || pathOnly.startsWith(p))) {
    return fb;
  }
  return { to: decoded, label: labelForReturn(decoded) };
}
